import { MockPolicyId } from "../mockPolicies";
import { getHdc1Dot0Membership } from "../builders/getHdc1Dot0Membership";
import { legacyUsAaaMember } from "../mockMembers";
import { getMockPolicies } from "../builders/getMockPolicies";

import { MockPersona } from "./mockPersonas.types";

const usPolicies: MockPolicyId[] = ["ghi789", "def456"];

export const maryNobroker: MockPersona = {
  key: "maryNobroker",
  name: "Mary Nobroker",
  description: "🇺🇸 | Multiple policies with no broker | HDC 1.0 AAA | ESign alert",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: getMockPolicies(...usPolicies),
        canada: [],
      },
    },
    hdc: {
      fetch1Dot0Membership: getHdc1Dot0Membership({ ProductCode: "USMEMB0" }),
    },
    esign: {
      fetchESignDocuments: [{ Id: 1, StateRegion: "AZ" }],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "mary@nobroker.com",
            firstName: "Mary",
            middleName: "",
            lastName: "Nobroker",
            mailingAddress: {
              line1: "4623 Blue Spruce Lane",
              line2: "",
              city: "Baltimore",
              state: "MD",
              postalCode: "21212",
              country: "USA",
            },
            preferredPhone: "4103728272",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000021",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: legacyUsAaaMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
